module.exports = __webpack_public_path__ + "img/image5.290ba359.png";